/* eslint-disable @typescript-eslint/no-empty-function */
import { createStore } from "vuex";

export const store = createStore({
  state: {
    unreadMessages: 0,
    treatmentProgress: null,
    info: {
      opened: false,
      title: "Info title",
      text: "info text paragraph",
      isConfirmation: false,
      onConfirm: null,
      onCancel: null
    },
    success: {
      opened: false,
      title: "success title",
      text: "success text paragraph",
      isConfirmation: false,
      onConfirm: null,
      onCancel: null
    },
    warning: {
      opened: false,
      title: "warning title",
      text: "warning text paragraph",
      isConfirmation: false,
      onConfirm: null,
      onCancel: null
    },
    danger: {
      opened: false,
      title: "danger title",
      text: "danger text paragraph",
      isConfirmation: false,
      onConfirm: null,
      onCancel: null
    }
  },
  getters: {
    getTreatmentProgress: state => state.treatmentProgress,
    getUnreadMessages: state => state.unreadMessages
  },
  mutations: {
    setMainProgress(state, percentage) {
      state.treatmentProgress = percentage
    },
    setUnreadMessages(state, unreadMessages) {
      state.unreadMessages = unreadMessages
    },
    open(state, data) {
      // mutate state
      if (data.type === "info") {
        state.info.opened = true;
        state.info.title = data.title;
        state.info.text = data.text;
        state.info.isConfirmation = data.isConfirmation;
        state.info.onConfirm = data.onConfirm;
        state.info.onCancel = data.onCancel;
      } else if (data.type === "success") {
        state.success.opened = true;
        state.success.title = data.title;
        state.success.text = data.text;
        state.success.isConfirmation = data.isConfirmation;
        state.success.onConfirm = data.onConfirm;
        state.success.onCancel = data.onCancel;
      } else if (data.type === "warning") {
        state.warning.opened = true;
        state.warning.title = data.title;
        state.warning.text = data.text;
        state.warning.isConfirmation = data.isConfirmation;
        state.warning.onConfirm = data.onConfirm;
        state.warning.onCancel = data.onCancel;
      } else if (data.type === "danger") {
        state.danger.opened = true;
        state.danger.title = data.title;
        state.danger.text = data.text;
        state.danger.isConfirmation = data.isConfirmation;
        state.danger.onConfirm = data.onConfirm;
        state.danger.onCancel = data.onCancel;
      }
    },
    close(state, data) {
      // mutate state
      if (data.type === "info") {
        state.info.opened = false;
        state.info.title = "";
        state.info.text = "";
        state.info.isConfirmation = false;
        state.info.onConfirm = null;
        state.info.onCancel = null;
      } else if (data.type === "success") {
        state.success.opened = false;
        state.success.title = "";
        state.success.text = "";
        state.success.isConfirmation = false;
        state.success.onConfirm = null;
        state.success.onCancel = null;
      } else if (data.type === "warning") {
        state.warning.opened = false;
        state.warning.title = "";
        state.warning.text = "";
        state.warning.isConfirmation = false;
        state.warning.onConfirm = null;
        state.warning.onCancel = null;
      } else if (data.type === "danger") {
        state.danger.opened = false;
        state.danger.title = "";
        state.danger.text = "";
        state.danger.isConfirmation = false;
        state.danger.onConfirm = null;
        state.danger.onCancel = null;
      }
    }
  },
  actions: {
    setMainProgress(context, percentage) {
      context.commit('setMainProgress', percentage)
    },
    setUnreadMessages(context, unreadMessages) {
      context.commit('unreadMessages', unreadMessages)
    },
    open(context, data) {
      context.commit("open", data);
    },
    close(context, data) {
      context.commit("close", data);
    }
  }
});
